import {useEffect} from 'react'
import {KTIcon, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {UploadBulkData} from './UploadBulkData'
import {useListFailedView} from '../../core/ListFailedProvider'
import {FailedRecords} from './FailedRecords'
import _ from 'lodash'

function SampleClassifiedModal({closeSampleModal, fileName}) {
  const {data, setFailedList} = useListFailedView()

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  const downloadSampleExcel = () => {
    const publicFilePath = toAbsoluteUrl(`/files/${fileName}`)
    const downloadLink = document.createElement('a')
    downloadLink.href = publicFilePath
    downloadLink.download = fileName
    downloadLink.click()
    closeSampleModal(false)
  }

  const closeModal = () => {
    setFailedList({existingBusiness: [], invalidBusiness: []})
    closeSampleModal(false)
  }

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className='modal-dialog modal-dialog-centered mw-800px'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h2 className='fw-bolder'>Import Excel</h2>
              <div
                className='btn btn-icon btn-sm btn-active-icon-primary'
                data-kt-users-modal-action='close'
                onClick={closeModal}
                style={{cursor: 'pointer'}}
              >
                <KTIcon iconName='cross' className='fs-1' />
              </div>
            </div>

            <div className='modal-body scroll-y mx-5 mx-lg-15 my-7'>
              {/* Download Sample Section */}
              <div className='mb-7'>
                <div className='text-center mb-4'>
                  <p className='text-gray-600 fs-6 mb-0'>
                    Download the sample Excel file to see the required format for bulk import
                  </p>
                </div>
                <div className='d-flex justify-content-center'>
                  <button
                    onClick={downloadSampleExcel}
                    type='button'
                    className='btn btn-light-primary d-flex align-items-center'
                  >
                    <KTIcon iconName='exit-down' className='fs-2 me-2' />
                    Download Sample Excel
                  </button>
                </div>
              </div>

              {/* Divider */}
              <div className='separator separator-dashed my-7'></div>

              {/* Upload Section */}
              <div className='mb-7'>
                <div className='text-center mb-5'>
                  <h3 className='fw-bold fs-4 mb-2'>Upload Your Excel File</h3>
                  <p className='text-gray-600 fs-6 mb-0'>
                    Select Category and SubCategory, then upload your Excel file
                  </p>
                </div>
                <UploadBulkData />
              </div>

              {/* Failed Records Section */}
              {!_.isEmpty(data.existingBusiness) || !_.isEmpty(data.invalidBusiness) ? (
                <>
                  <div className='separator separator-dashed my-7'></div>
                  <FailedRecords />
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}

export {SampleClassifiedModal}
